export const WindowWidthDesktop = 1024;
